import type { GuidedModeQuestionOutput } from '../types/guided-mode.types'

export function toggleMultipleOption(
  selectedValues: string[],
  value: string,
  exclusiveValues: string[] = [],
): string[] {
  const selected = new Set(selectedValues)
  const exclusive = new Set(exclusiveValues)

  if (selected.has(value)) selected.delete(value)
  else if (exclusive.has(value)) return [value]
  else {
    exclusive.forEach(exclusiveValue => selected.delete(exclusiveValue))
    selected.add(value)
  }

  return [...selected]
}

export function buildQuestionOutputAnswers(
  selectedValues: string[],
  outputs: GuidedModeQuestionOutput[] = [],
): Record<string, 'yes' | 'no'> {
  const selected = new Set(selectedValues)
  return Object.fromEntries(outputs.map(output => [
    output.conceptId,
    selected.has(output.responseValue) ? output.selectedValue : output.unselectedValue,
  ]))
}
